import clsx from 'clsx';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Post } from 'src/apis/api';
import Loading from 'src/components/Loading';
import CustomInput from 'src/components/UI/customInput/customInput';
import { CompleteVisa } from 'src/components/visaActions/CompleteVisa';
import FormNumberThree from 'src/pages/visa-orders/forms/formNumberThree';
import FormNumberTwo from 'src/pages/visa-orders/forms/formNumberTwo';
import { VisaItemType } from 'src/types'
import { createFileURL } from 'src/utils/new';

export const AdminData = ({ onSuccessMutate, record }: { record: VisaItemType } & { onSuccessMutate: Function }) => {

    const { t } = useTranslation();

    const { automation_number, letter_number, command_letter_file, command_letter_number, id, visa, status , otb_file } = record

    const [numbers, setNumbers] = useState<{ command?: string, auto?: string }>({command:command_letter_number , auto:automation_number})

    const [proceesLoading, setProcessLoading] = useState<boolean>(false)

    const [createCommandPDF, setCreateCommandPDF] = useState<(() => Promise<Blob>) | undefined>(undefined)

    const [createOKTBPDF, setCreateOKTBPDF] = useState<(() => Promise<Blob>) | undefined>(undefined)




    const isAtabLetterSent = !!letter_number

    const isAutomationSent = !!automation_number


    const commandTitle = "فرماندهی محترم نیروی انتظامی (اتباع خارجی)"


    const sendCommandLetter = async () => {

        if (!createCommandPDF)
            return Promise.reject()

        const commandPDF = await createCommandPDF()

        const formData = new FormData()

        formData.append('form', "command_letter_from")
        formData.append('command_letter_number', (numbers.command ?? '')?.toString())


        if (commandPDF) {
            formData.append('command_letter_file', commandPDF, 'command-doc.pdf')
        }


        return Post(`/admin/visas/send-command-letter/${id}`, formData)

    }


    const saveAutomation = () => {


        if (!numbers.auto) {

            return Promise.reject()
        }
        return Post(`/admin/visas/save-automation/${id}`, {
            form: "admin_automation_number",
            automation_number: numbers.auto
        })
    }


    const sendOTB = async () => {

        const formData = new FormData();

        if (!createCommandPDF) {
            alert('The OKTB Letter is Not Ready')
            return Promise.reject
        }
        else {

            const oktbPDF = createOKTBPDF ? await createOKTBPDF() : undefined

            if (!oktbPDF) {
                alert('The OKTB Letter is Not Ready')
                return Promise.reject()
            }


            if (!numbers.auto) {
                alert('Automation Number is Not Entered!')
                return Promise.reject()
            }
            formData.append("form", "otb_from");
            formData.append("subject", "OK TO BOARD");
            formData.append("otb_file", oktbPDF, 'my-document.pdf');
            formData.append("automation_number", numbers.auto)
            formData.append("email_body", "OK TO BOARD")


        }
        return Post(`/admin/visas/send-otb/${id}`, formData)
    }




    const { mutate: mutateAll, isLoading: loadingCommnad } = useMutation({
        mutationFn: () => {
            setProcessLoading(true)
            if (visa?.need_otb ) { //If No Need For Resending OKTB => && !otb_file
                return Promise.all([sendOTB(), ...(!command_letter_number ?  [sendCommandLetter()] : [])])
            }

            else return Promise.all([saveAutomation(),...(!command_letter_number ?  [sendCommandLetter()] : [])])
        },

        mutationKey: ['MutateAll', id],
        onSuccess: (res: Array<any>) => {

            if (Array.isArray(res))
                res?.forEach(f => toast.success(f?.msg))

            onSuccessMutate()

        },
        onError: (error: any) => {
            if (Array.isArray(error))
                error?.forEach(error => toast.error(error?.data?.message || error?.data?.msg))
            else {
                toast.error(error?.data?.message || error?.data?.msg)
            }

        },
        onSettled: () => {
            setProcessLoading(false)
        }
        // })

    })



    const handleSaving = () => {
        if (!numbers.auto) {
            return toast.info(t('automationNumberIsNotEntered'))
        }

        if (!numbers.command)
            return toast.success(t('CommandNumberIsNotEntered'))

        setProcessLoading(true)

        mutateAll()


    }

    const loading = proceesLoading || loadingCommnad



    return (
        <>

            {(isAtabLetterSent ) ? 

                <>
                    <div className='flex flex-row gap-8 whitespace-nowrap items-center'>
                        <span className='w-36 '>{t('CommandLetterNumber')}</span>
                            <CustomInput
                                placeHolder={t("CommandLetterNumber")}
                                label={t("CommandLetterNumber")}
                                name={"CommandLetter" + id}
                                onchange={(e: any) => setNumbers({ ...numbers, command: e?.value })}
                                defaultValue={numbers.command}
                                disable={loading || !!command_letter_number}
                                className={'bg-white '}
                                maxLength={10}
                            />


                    </div>


                    <div className='flex flex-row gap-8 items-center whitespace-nowrap'>
                        <span className='w-36'>شماره اتوماسیون</span>
                            <CustomInput
                                placeHolder={t("automationNumber")}
                                label={t("automationNumber")}
                                name={"automationNumber" + id}
                                onchange={(e: any) => setNumbers({ ...numbers, auto: e?.value })}
                                defaultValue={numbers.auto}
                                disable={loading }
                                className={'bg-white'}
                                maxLength={10}
                            />

                    </div>

                    <FormNumberThree
                        id={id}
                        onPdf={(e: Blob) => { }}
                        setLoading={(state: boolean) => setProcessLoading(state)}
                        atNumber={numbers.auto}
                        createPDFasync={createOKTBPDF}
                        setCreatePDFasync={setCreateOKTBPDF}

                    />

                    <FormNumberTwo
                        activeStep={undefined}
                        defaultId={id}
                        atNumber={numbers.auto}
                        createPDFasync={createCommandPDF}
                        setCreatePDFasync={setCreateCommandPDF}

                        defaultLetterNumber={numbers.command}
                        defaultEmails={[{ title: commandTitle }]}

                        mode='pdf'


                    />


                   <button
                        disabled={loading}
                        className={clsx('bg-primary-300 text-white rounded-lg p-2  flex-row flex justify-center', loading && 'grayscale')}
                        onClick={handleSaving}
                    >{loading ? <Loading /> : t('save')}</button>
                    



                </>
                : <span className='text-sm text-center text-gray-800'>{t('WaitForNationalityOfficeLetter')}</span>}

            {command_letter_file && <button onClick={() => window.open(createFileURL(command_letter_file))}
                className='bg-amber-100 text-amber-600 border border-amber-600  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                title={`${t('View')} ${t('ViewCommandLetter')}`}
            >
                {t('ViewCommandLetter')}
            </button>}

            {!!otb_file && <button onClick={() => window.open(`https://api.flysepehr.com/storage${otb_file}`)}
              className='bg-teal-100 text-teal-600 border-teal-600 border duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
              title={`${t('View')} OKTB`}
            >
              {t('View') } OKTB
            </button>}



            {(status == 1) && <Link to={`/visa-orders/forms/${id}`}
                className='bg-green-100 text-green-200 border border-green-300 duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                title={`${t('Send')} ${t('NationalityOfficeLetter')}`}
            >
                {t('Send')} {t('NationalityOfficeLetter')}
            </Link>}


            {!!letter_number && <Link to={`/visa-orders/forms/${id}`}
                className='bg-purple-100 text-purple-600 border border-purple-600  duration-200 p-2 rounded-lg  text-sm font-bold lg:min-w-32 flex flex-row items-center justify-center'
                title={`${t('View')} ${t('NationalityOfficeLetter')}`}
            >
                {t('View')} {t('NationalityOfficeLetter')}
            </Link>}

            {!!command_letter_number  &&  status!=15 && <CompleteVisa visaId={id.toString()} onSuccessMutate={onSuccessMutate} />}



        </>
    )
}
